module.exports = __webpack_public_path__ + "static/media/double-left-pagination.5939dda6.svg";